import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';

@Directive({
    selector: '[passportExpiryDate]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PassportExpiryDateDirective, multi: true }]
})
export class PassportExpiryDateDirective implements Validator {
    @Input('passportExpiryDate') checkPassportExpiryDate: string[] = [];

    validate(formGroup: FormGroup): ValidationErrors {
        return validatePassportExpiryDate(this.checkPassportExpiryDate[0])(formGroup);
    }
}

function validatePassportExpiryDate(passportExpiryDate: string) {
    return (formGroup: FormGroup) => {
        const formGroupPassportExpiryDateObject = formGroup.controls[passportExpiryDate];
        if (!formGroupPassportExpiryDateObject) {
            return null;
        }

        if(formGroupPassportExpiryDateObject.value === undefined || formGroupPassportExpiryDateObject.value === null  || formGroupPassportExpiryDateObject.value === '' ){
            return null;
        }

        const actualPassportExpiryDateValue = formGroupPassportExpiryDateObject.value;
        const aactualPassportExpiryDateValueArr = actualPassportExpiryDateValue.split('/');
        const requiredPassportExpiryDateValue = aactualPassportExpiryDateValueArr[1] + '/' + aactualPassportExpiryDateValueArr[0] + '/' + aactualPassportExpiryDateValueArr[2]
        const passportExpiryDateValue = new Date(requiredPassportExpiryDateValue);
        const todayDate = new Date();

        if (passportExpiryDateValue.getTime() < todayDate.getTime()) {
            formGroupPassportExpiryDateObject.setErrors({ hasError: true, errorMessage: 'Passport Expiry Date can not be past date'});
            return;
        }

        let nextDate = todayDate;
        nextDate.setMonth(todayDate.getMonth() + 6);
        if(passportExpiryDateValue < nextDate){
            formGroupPassportExpiryDateObject.setErrors({ hasError: true, errorMessage: 'Passports must have a minimum validity of atleast six months as on the date of submission of application for visa.'});
            return;
        }

        return null;
    }

}
